// NOTE:
// File sizes are defined in KILOBYTES (KB)
// 1 KB = 1024 bytes
// Validation logic must convert KB → BYTES when comparing with file.size

export const FileSizeLimit = {
    /**
     * ICON IMAGE (SVG ONLY)
     * ----------------------------------------
     * ✅ Allowed:
     * - SVG files only
     * - File size between 1 KB and 2 MB
     *
     * ❌ Not Allowed:
     * - JPG, PNG, WEBP, GIF, etc.
     * - Files smaller than 1 KB
     * - Files larger than 2 MB
     */
    icon: {
        min_size: 0,            // Minimum file size: 1 KB
        max_size: 2048,         // Maximum file size: 2048 KB (2 MB)
        message: 'File size must be between 0 KB and 2 MB',

        // MIME types allowed for icon upload
        allowedTypes: [
            'image/svg+xml',
            'image/svg',
            'image/webp'
        ],

        // Tooltip shown in UI
        tooltipItems: {
            title: 'Image requirements',
            position: 'top',
            items: [
                'Icon - SVG icon for grid-based category collection',
                'Formats: SVG And WEBP only',
                'File size: Up to 2 MB',
            ],
        },
    },

    /**
     * CHIP IMAGE
     * ----------------------------------------
     * ✅ Allowed:
     * - JPG, JPEG, PNG images
     * - File size between 500 KB and 1 MB
     *
     * ❌ Not Allowed:
     * - SVG, WEBP, GIF
     * - Files smaller than 500 KB
     * - Files larger than 1 MB
     */
    chip_image: {
        min_size: 0,          // Minimum file size: 500 KB
        max_size: 2048,         // Maximum file size: 1024 KB (1 MB)
        message: 'File size must be between 0 KB and 2 MB',

        allowedTypes: [
            'image/jpeg',
            'image/png',
            'image/jpg',
            'image/webp'
        ],
        tooltipItems: {
            title: 'Image requirements',
            items: [
                'Dimensions: 163 × 60 px',
                'Formats: JPG, PNG, JPGE, WEBP',
                'File size: Up to 2 MB',
            ],
            position: 'top',
        }
    },
    cardImage1: {
        min_size: 0,          // Minimum file size: 500 KB
        max_size: 2048,         // Maximum file size: 1024 KB (1 MB)
        message: 'File size must be between 0 KB and 2 MB',

        allowedTypes: [
            'image/jpeg',
            'image/png',
            'image/jpg',
            'image/webp'
        ],
        tooltipItems: {
            title: 'Image requirements',
            items: [
                'Dimensions: 328 ×  128 px',
                'Formats: JPG, PNG, JPGE, WEBP',
                'File size: Up to 2 MB',
            ],
            position: 'top',
        }
    },
    cardImage2: {
        min_size: 0,          // Minimum file size: 500 KB
        max_size: 2048,         // Maximum file size: 1024 KB (1 MB)
        message: 'File size must be between 0 KB and 2 MB',

        allowedTypes: [
            'image/jpeg',
            'image/png',
            'image/jpg',
            'image/webp'
        ],
        tooltipItems: {
            title: 'Image requirements',
            items: [
                'Dimensions: 328 ×  128 px',
                'Formats: JPG, PNG, JPGE, WEBP',
                'File size: Up to 2 MB',
            ],
            position: 'top',
        }
    },
    thumbnail: {
        min_size: 0,
        max_size: 2048,
        message: 'File size must be between 0 KB and 2 MB',

        allowedTypes: [
            'image/jpeg',
            'image/png',
            'image/jpg',
            'image/webp',
            'image/gif'
        ],
        tooltipItems: {
            title: 'Image requirements',
            items: [
                'Dimensions: 118 × 177 px',
                'Formats: JPG, PNG, JPEG, WEBP, GIF',
                'File size: Up to 2 MB',
            ],
            position: 'right',
        }
    },

    banner_image: {
        min_size: 0,          // Minimum file size: 500 KB
        max_size: 1024,         // Maximum file size: 1024 KB (1 MB)
        message: 'File size must be between 0 KB and 1 MB',

        allowedTypes: [
            'image/jpeg',
            'image/png',
            'image/jpg',
            'image/webp'
        ],
        tooltipItems: {
            title: 'Image requirements',
            items: [
                'Dimensions: 360 × 272 px',
                'Formats: JPG, PNG, JPGE, WEBP',
                'File size: up to 1 MB',
            ],
            position: 'top',
        }
    },

    video: {
        max_size: 500,  
               //(only video is in mb)
        max_duration: 180,  //seconds (only video is in seconds) 60 seconds = 1 minute
        message: 'File size must be less than 500 MB',
        allowedTypes: [
            'video/mp4',
            'video/webm',
            'video/webm',
            'video/mov'
        ],
        tooltipItems: {
            title: 'Video requirements',
            items: [
                'Formats: MP4, WEBM, OGG, MOV',
                'File size: 500 MB',
            ],
            position: 'top',
        }
}
}
